import NewCategory from "features/finance/NewCategory";

const NewCategoryPage = () => {
    return (
        <>
            <NewCategory />
        </>
    )
}
export default NewCategoryPage